export const PartnersCompletenessDialogContentTranslations = {
  title: 'jbp-partners-completeness-title',
  subTitle: 'jbp-partners-completeness-sub-title',

  showCompleted: 'jbp-partners-completeness-show-completed',
  showNotCompleted: 'jbp-partners-completeness-show-not-completed',

  infoCompleted: 'jbp-partners-completeness-info-completed',
  infoNotCompleted: 'jbp-partners-completeness-info-not-completed',

  columnPartnerId: 'jbp-spt-partner-id-column',
  columnLocationId: 'jbp-spt-location-id-column',
  columnPartnerName: 'jbp-spt-partner-name-column',
  columnMarket: 'jbp-spt-market-column',
  columnCountry: 'jbp-spt-country-column',
  columnHierarchy: 'jbp-spt-hierarchy-column',

  closeButton: 'jbp-partners-completeness-close',
}

export default PartnersCompletenessDialogContentTranslations
